import { render, staticRenderFns } from "./ProfilePanel.vue?vue&type=template&id=7cc522cb&"
import script from "./ProfilePanel.vue?vue&type=script&lang=ts&"
export * from "./ProfilePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports